import {
  DocumentIcon,
  HomeIcon,
  PersonIcon,
  StatsIcon,
} from "components/Icons/Icons";
import EmailBlastBuilder from "views/Applications/EmailBlastBuilder";
import S3Upload from "views/Applications/s3Upload";
import Default from "views/Dashboard/Default";
import Settings from "views/Pages/Account/Settings";
import NewUser from "views/Pages/Users/NewUser";
import Users from "views/Pages/Users/Users";
import NewClient from "views/Pages/Clients/NewClient";
import Clients from "views/Pages/Clients/Clients";
import TaskManager from "views/Applications/TaskManager";
import SignInCover from "views/Authentication/SignIn/SignInCover";
import { FaUsers } from "react-icons/fa";
import BudgetOverview from "views/Pages/Clients/BudgetOverview";
import BudgetEditor from "views/Pages/Clients/BudgetEditor";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import ZohoAuth from "views/Pages/ZohoAuth/ZohoAuth";
import Widgets from "views/Pages/Widgets";
import Onboarding from "views/Pages/Onboarding/Onboarding";
import BudgetArchive from "views/Pages/Clients/BudgetArchive";
import InactiveClients from "views/Pages/Clients/inactiveClients";

const routes = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: <HomeIcon color="inherit" />,
    authIcon: <HomeIcon color="inherit" />,
    collapse: true,
    allowedRoles: ["User"],
    items: [
      {
        name: "Default",
        path: "/dashboard",
        component: Default,
        layout: "/admin",
      },
    ],
  },
  // {
  //   name: "Onboarding",
  //   path: "/onboarding",
  //   icon: <HomeIcon color="inherit" />,
  //   authIcon: <HomeIcon color="inherit" />,
  //   collapse: true,
  //   allowedRoles: ["SuperAdmin", "Admin", "Dev"],
  //   items: [
  //     {
  //       name: "Onboarding",
  //       path: "/onboarding",
  //       component: Onboarding,
  //       layout: "/admin",
  //     },
  //     // {
  //     //   name: "Onboarding Editor",
  //     //   path: "/onboarding-test",
  //     //   component: Onboarding,
  //     //   layout: "/admin",
  //     // },
  //   ],
  // },
  {
    name: "Clients",
    path: "/clients",
    icon: <FaUsers color="inherit" />,
    authIcon: <FaUsers color="inherit" />,
    collapse: true,
    allowedRoles: ["User"],
    items: [
      {
        name: "Client List",
        path: "/clients/client-list",
        component: Clients,
        layout: "/admin",
        allowedRoles: ["User"],
      },
      {
        name: "Inactive Client List",
        path: "/clients/inactive-client-list",
        component: InactiveClients,
        layout: "/admin",
        allowedRoles: ["User"],
      },
      {
        name: "New Client",
        path: "/clients/new-client/",
        component: NewClient,
        layout: "/admin",
        allowedRoles: ["Dev", "Admin", "SuperAdmin", "Manager"],
      },
    ],
  },
  // {
  //   name: "Budgets",
  //   path: "/budgets",
  //   icon: <FaMoneyBillTrendUp color="inherit" />,
  //   authIcon: <FaMoneyBillTrendUp color="inherit" />,
  //   collapse: true,
  //   allowedRoles: [
  //     "Rep",
  //     "Social",
  //     "Search",
  //     "Admin",
  //     "SuperAdmin",
  //     "Dev",
  //     "Manager",
  //   ],
  //   items: [
  //     {
  //       name: "Budget Overview",
  //       path: "/budgets/budget-overview",
  //       component: BudgetOverview,
  //       layout: "/admin",
  //     },
  //     {
  //       name: "Budget Editor",
  //       path: "/budgets/budget-editor",
  //       component: BudgetEditor,
  //       layout: "/admin",
  //     },
  //     {
  //       name: "Budget Archive",
  //       path: "/budgets/budget-archive",
  //       component: BudgetArchive,
  //       layout: "/admin",
  //     },
  //   ],
  // },
  {
    name: "Applications",
    path: "/applications",
    icon: <StatsIcon color="inherit" />,
    authIcon: <StatsIcon color="inherit" />,
    collapse: true,
    allowedRoles: ["Support", "Admin", "SuperAdmin", "Dev", "Rep"],
    items: [
      {
        name: "S3 Upload",
        component: S3Upload,
        authIcon: <DocumentIcon color="inherit" />,
        path: "/applications/s3-upload/",
        layout: "/admin",
        allowedRoles: ["Admin", "SuperAdmin", "Support"],
      },
      {
        name: "Email Blast Builder",
        component: EmailBlastBuilder,
        authIcon: <DocumentIcon color="inherit" />,
        path: "/applications/email-blast-builder/",
        layout: "/admin",
        allowedRoles: ["Admin", "SuperAdmin", "Support"],
      },
      {
        name: "Task Manager",
        component: TaskManager,
        authIcon: <DocumentIcon color="inherit" />,
        path: "/applications/task-manager/",
        layout: "/admin",
        allowedRoles: ["Admin", "SuperAdmin", "Dev", "Manager", "Rep"],
      },
    ],
  },
  {
    name: "Profile",
    path: "/profile",
    icon: <PersonIcon color="inherit" />,
    authIcon: <PersonIcon color="inherit" />,
    collapse: true,
    items: [
      {
        name: "My Account",
        path: "/my-account/",
        component: Settings,
        layout: "/admin",
      },
    ],
  },
  {
    name: "Administrator",
    path: "/administrator",
    icon: <StatsIcon color="inherit" />,
    authIcon: <StatsIcon color="inherit" />,
    collapse: true,
    allowedRoles: ["Admin", "SuperAdmin", "Dev", "Manager"],
    items: [
      {
        name: "Users",
        path: "/administrator/users",
        component: Users,
        layout: "/admin",
      },
      {
        name: "New User",
        path: "/administrator/new-user",
        component: NewUser,
        layout: "/admin",
      },
      {
        name: "Zoho Auth",
        path: "/administrator/zoho-auth",
        component: ZohoAuth,
        layout: "/admin",
        allowedRoles: ["Dev"],
      },
      // {
      //   name: "Widgets",
      //   component: Widgets,
      //   path: "/administrator/widgets",
      //   layout: "/admin",
      // },
      // {
      //   name: "Charts",
      //   component: Charts,
      //   path: "/administrator/charts",
      //   layout: "/admin",
      // },
      // {
      //   name: "Alerts",
      //   path: "/administrator/alerts",
      //   component: Alerts,
      //   layout: "/admin",
      // },
    ],
  },
  {
    name: "Auth",
    path: "/auth",
    icon: <StatsIcon color="inherit" />,
    authIcon: <StatsIcon color="inherit" />,
    collapse: true,
    items: [
      {
        name: "Sign In",
        path: "/sign-in",
        component: SignInCover,
        layout: "/auth",
      },
    ],
  },
  // {
  //   name: "Projects",
  //   path: "/projects",
  //   icon: <StatsIcon color="inherit" />,
  //   authIcon: <StatsIcon color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: "General",
  //       path: "/projects/general",
  //       component: General,
  //       layout: "/admin",
  //     },
  //     {
  //       name: "Timeline",
  //       path: "/projects/timeline",
  //       component: Timeline,
  //       layout: "/admin",
  //     },
  //   ],
  // },
];

export default routes;
